import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.composing-termsOfUseModal.title',
    defaultMessage: 'Terms of Use',
  },
  back: {
    id: 'simulated.composing-termsOfUseModal.back',
    defaultMessage: 'Back',
  },
  agreeAndContinue: {
    id: 'simulated.composing-termsOfUseModal.agreeAndContinue',
    defaultMessage: 'Agree and Continue',
  },
});
